module.exports = __webpack_public_path__ + "img/back-button.aa5401fc.png";